import React from 'react';
import type { WineColorCanonical } from '../../../utils/wineColor';
import { dotVarFor } from './laCarteModel';

export interface RailEntry {
  color: WineColorCanonical | 'OTHER';
  label: string;
}

interface Props {
  entries: RailEntry[];
  /** Section currently in view (scroll tracking) — underlined. */
  active: string | null;
  /** Isolated color, or null. Isolation wins over active. */
  isolated: string | null;
  onTap: (color: RailEntry['color']) => void;
}

/**
 * Scroll-snapped color rail — the filter is navigation:
 * tap a color to jump to its section; tap the active color again to isolate
 * it; tap the isolated color to clear. (Semantics live in the page; this is
 * the presentational strip.)
 */
const ColorRail: React.FC<Props> = ({ entries, active, isolated, onTap }) => (
  <nav className="lc-rail" aria-label="Wine colors">
    {entries.map(e => {
      const iso = isolated === e.color;
      const act = active === e.color && !isolated;
      return (
        <button
          key={e.color}
          type="button"
          className={`${act ? 'lc-active' : ''} ${iso ? 'lc-active lc-isolated' : ''}`.trim() || undefined}
          aria-pressed={iso}
          onClick={() => onTap(e.color)}
        >
          <span className="lc-dot" style={{ background: dotVarFor(e.color) }} />
          {e.label}{iso ? ' ×' : ''}
        </button>
      );
    })}
  </nav>
);

export default ColorRail;
